var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector",
    viewBox: "0 0 26 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    style: {},
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 6.4,
    d: "M5.172 3.2l14.169 12.8-14.169 12.8"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.414 27.414l10-10c0.781-0.781 0.781-2.047 0-2.828l-10-10c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586h-19.172c-1.105 0-2 0.895-2 2s0.895 2 2 2h19.172l-6.586 6.586c-0.39 0.39-0.586 0.902-0.586 1.414s0.195 1.024 0.586 1.414c0.781 0.781 2.047 0.781 2.828 0z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-telega",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.612 19.671l-0.49 6.444c0.703 0 1.007-0.282 1.372-0.62l3.292-2.938 6.822 4.665c1.251 0.65 2.134 0.307 2.473-1.075l4.477-19.587c0.399-1.727-0.669-2.401-1.887-1.978l-26.323 9.407c-1.796 0.652-1.77 1.585-0.305 2.012l6.729 1.952 15.632-9.129c0.736-0.455 1.405-0.204 0.855 0.252l-12.647 10.596z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fbook",
    viewBox: "0 0 16 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.143 15.971h-4.033v14.865h-6.112v-14.865h-2.906v-5.222h2.906v-3.382c0-2.417 1.142-6.204 6.167-6.204l4.527 0.019v5.072h-3.284c-0.538 0-1.297 0.272-1.297 1.425v3.073h4.567l-0.534 5.219z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-git",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.789 0-16 7.211-16 16 0 7.499 5.262 14.312 12.25 16v-5.293c-0.276 0.070-0.593 0.109-0.919 0.109-0.398 0-0.781-0.059-1.143-0.169l0.028 0.007c-0.946-0.278-1.714-0.909-2.285-1.869-0.363-0.613-1.008-1.28-1.68-1.23l-0.165-1.867c1.454-0.125 2.71 0.886 3.456 2.139 0.333 0.558 0.715 0.885 1.205 1.029 0.472 0.141 0.981 0.074 1.573-0.136 0.149-1.186 0.693-1.629 1.104-2.256-4.168-0.621-5.829-2.832-6.488-4.576-0.874-2.318-0.405-5.213 1.139-7.043 0.030-0.035 0.085-0.128 0.064-0.192-0.709-2.141 0.154-3.91 0.186-4.098 0.818 0.24 0.95-0.243 3.552 1.336l0.448 0.27c0.189 0.112 0.128 0.048 0.317 0.032 1.003-0.282 2.157-0.452 3.349-0.469l0.010-0c1.136 0.014 2.272 0.176 3.403 0.483l0.146 0.016c-0.013-0.003 0.040-0.010 0.128-0.062 3.248-1.968 3.131-1.325 4.003-1.608 0.032 0.189 0.882 1.987 0.182 4.099-0.096 0.291 2.816 2.957 1.202 7.235-0.659 1.744-2.32 3.957-6.486 4.578 0.534 0.816 1.176 1.248 1.173 2.928v6.606c6.986-1.688 12.25-8.501 12.25-16 0-8.789-7.211-16-16-16z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Burger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M0 6.4h32M0 16h32M0 25.6h32"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M2.52 2l26.96 28M2 29.48l28-26.96"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.968 9.408c-0.074-1.701-0.349-2.869-0.742-3.882-0.424-1.111-1.054-2.059-1.85-2.837l-0.001-0.001c-0.78-0.792-1.724-1.419-2.778-1.827l-0.054-0.018c-1.019-0.394-2.181-0.667-3.882-0.742-1.712-0.082-2.256-0.101-6.602-0.101-4.344 0-4.888 0.019-6.595 0.094-1.699 0.074-2.869 0.349-3.88 0.742-1.112 0.424-2.060 1.054-2.839 1.85l-0.001 0.001c-0.791 0.78-1.418 1.724-1.825 2.778l-0.018 0.054c-0.395 1.019-0.669 2.181-0.744 3.882-0.082 1.712-0.101 2.256-0.101 6.602 0 4.344 0.019 4.888 0.094 6.595 0.075 1.701 0.35 2.869 0.744 3.882 0.426 1.11 1.055 2.057 1.849 2.837l0.001 0.001c0.8 0.813 1.77 1.443 2.832 1.843 1.019 0.395 2.182 0.67 3.882 0.744 1.707 0.075 2.251 0.094 6.595 0.094 4.346 0 4.89-0.019 6.595-0.094 1.701-0.074 2.869-0.349 3.882-0.742 2.157-0.85 3.833-2.526 4.664-4.628l0.019-0.055c0.394-1.019 0.669-2.182 0.744-3.882 0.075-1.707 0.093-2.251 0.093-6.595s-0.006-4.888-0.080-6.595zM29.088 22.474c-0.070 1.563-0.333 2.406-0.55 2.97-0.552 1.399-1.64 2.486-3.004 3.024l-0.036 0.012c-0.56 0.219-1.411 0.482-2.968 0.55-1.688 0.075-2.194 0.094-6.464 0.094-4.269 0-4.782-0.019-6.464-0.094-1.563-0.069-2.406-0.331-2.97-0.55-0.721-0.269-1.334-0.676-1.836-1.192l-0.001-0.001c-0.517-0.503-0.924-1.117-1.184-1.803l-0.011-0.034c-0.218-0.563-0.48-1.413-0.549-2.97-0.075-1.688-0.094-2.195-0.094-6.464 0-4.27 0.019-4.784 0.094-6.464 0.069-1.563 0.331-2.406 0.549-2.97 0.269-0.722 0.678-1.337 1.198-1.837l0.002-0.002c0.504-0.517 1.119-0.923 1.806-1.182l0.034-0.011c0.56-0.219 1.411-0.48 2.968-0.55 1.688-0.074 2.195-0.093 6.464-0.093 4.275 0 4.782 0.019 6.464 0.093 1.563 0.069 2.406 0.331 2.97 0.55 0.693 0.256 1.325 0.662 1.837 1.194 0.531 0.52 0.938 1.144 1.195 1.84 0.218 0.56 0.48 1.411 0.549 2.968 0.075 1.688 0.094 2.194 0.094 6.464 0 4.269-0.019 4.768-0.094 6.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.059 7.782c-4.539 0.002-8.218 3.682-8.219 8.221v0c0.091 4.471 3.737 8.060 8.221 8.060s8.13-3.589 8.221-8.052l0-0.009c-0.001-4.54-3.681-8.22-8.221-8.221h-0zM16.059 21.334c-2.945-0-5.332-2.388-5.332-5.333s2.388-5.333 5.333-5.333c0 0 0.001 0 0.001 0h-0c2.946 0 5.334 2.388 5.334 5.334s-2.388 5.334-5.334 5.334v0zM26.525 7.458c0 1.060-0.86 1.92-1.92 1.92s-1.92-0.86-1.92-1.92v0c0-1.060 0.86-1.92 1.92-1.92s1.92 0.86 1.92 1.92v0z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-smartphone",
    viewBox: "0 0 20 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0h-14c-1.654 0-3 1.346-3 3v26c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-26c0-1.654-1.346-3-3-3zM3 2h14c0.552 0 1 0.448 1 1v0 21h-16v-21c0-0.552 0.448-1 1-1v0zM17 30h-14c-0.552 0-1-0.448-1-1v0-3h16v3c0 0.552-0.448 1-1 1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.708 27.478c0.18 0.163 0.293 0.399 0.293 0.66s-0.113 0.497-0.292 0.659l-0.001 0.001c-0.186 0.17-0.435 0.275-0.708 0.275s-0.522-0.104-0.709-0.275l0.001 0.001c-0.18-0.163-0.293-0.399-0.293-0.66s0.113-0.497 0.292-0.659l0.001-0.001c0.186-0.17 0.435-0.275 0.708-0.275s0.522 0.104 0.709 0.275l-0.001-0.001z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 18.451l-16-12.42-16 12.42v-5.064l16-12.42 16 12.42zM28 18v12h-8v-8h-8v8h-8v-12l12-9z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 19l-6-6v-9h-4v5l-6-6-16 16v1h4v10h10v-6h4v6h10v-10h4z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-phone",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 20c-2 2-2 4-4 4s-4-2-6-4-4-4-4-6 2-2 4-4-4-8-6-8-6 6-6 6c0 4 4.109 12.109 8 16s12 8 16 8c0 0 6-4 6-6s-6-8-8-6z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-email",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 4h-26c-1.65 0-3 1.35-3 3v20c0 1.65 1.35 3 3 3h26c1.65 0 3-1.35 3-3v-20c0-1.65-1.35-3-3-3zM12.461 17.199l-8.461 6.59v-15.676l8.461 9.086zM5.512 8h20.976l-10.488 7.875-10.488-7.875zM12.79 17.553l3.21 3.447 3.21-3.447 6.58 8.447h-19.579l6.58-8.447zM19.539 17.199l8.461-9.086v15.676l-8.461-6.59z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pushpin",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0l-3 3 3 3-7 8h-7l5.5 5.5-8.5 11.269v1.231h1.231l11.269-8.5 5.5 5.5v-7l8-7 3 3 3-3-15-15zM14 17l-2-2 7-7 2 2-7 7z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pass",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 32c-0.072 0-0.144-0.008-0.217-0.024-0.458-0.102-0.783-0.507-0.783-0.976v-15h-15c-0.469 0-0.875-0.326-0.976-0.783s0.129-0.925 0.553-1.123l30-14c0.381-0.178 0.833-0.098 1.13 0.199s0.377 0.749 0.199 1.13l-14 30c-0.167 0.358-0.524 0.577-0.906 0.577zM5.508 14h11.492c0.552 0 1 0.448 1 1v11.492l10.931-23.423-23.423 10.931z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-redo2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7.762v-7.762l12 12-12 12v-7.932c-13.961-0.328-13.362 9.493-9.808 15.932-8.772-9.482-6.909-24.674 9.808-24.238z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bubble",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2c8.837 0 16 5.82 16 13s-7.163 13-16 13c-0.849 0-1.682-0.054-2.495-0.158-3.437 3.437-7.539 4.053-11.505 4.144v-0.841c2.142-1.049 4-2.961 4-5.145 0-0.305-0.024-0.604-0.068-0.897-3.619-2.383-5.932-6.024-5.932-10.103 0-7.18 7.163-13 16-13z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-enlarge2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0v13l-5-5-6 6-3-3 6-6-5-5zM14 21l-6 6 5 5h-13v-13l5 5 6-6z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shrink2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 18v13l-5-5-6 6-3-3 6-6-5-5zM32 3l-6 6 5 5h-13v-13l5 5 6-6z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-attachment",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.807 10.22l-2.030-2.029-10.15 10.148c-1.682 1.681-1.682 4.408 0 6.089s4.408 1.681 6.090 0l12.18-12.178c2.804-2.802 2.804-7.346 0-10.148-2.802-2.803-7.347-2.803-10.149 0l-12.788 12.787c-0.009 0.009-0.019 0.018-0.027 0.026-3.909 3.909-3.909 10.245 0 14.153 3.908 3.908 10.246 3.908 14.156 0 0.009-0.009 0.016-0.018 0.026-0.027l0.001 0.001 8.729-8.728-2.031-2.029-8.729 8.727c-0.009 0.008-0.018 0.018-0.026 0.026-2.784 2.783-7.312 2.783-10.096 0-2.783-2.783-2.783-7.31 0-10.093 0.010-0.009 0.019-0.018 0.028-0.026l-0.001-0.002 12.79-12.786c1.678-1.679 4.411-1.679 6.090 0s1.678 4.411 0 6.089l-12.18 12.178c-0.56 0.56-1.47 0.56-2.030 0-0.559-0.559-0.559-1.47 0-2.029l10.15-10.149z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3c-3.472 0-6.737 1.352-9.192 3.808s-3.808 5.72-3.808 9.192c0 3.472 1.352 6.737 3.808 9.192s5.72 3.808 9.192 3.808c3.472 0 6.737-1.352 9.192-3.808s3.808-5.72 3.808-9.192c0-3.472-1.352-6.737-3.808-9.192s-5.72-3.808-9.192-3.808zM16 0v0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM14 22h4v4h-4zM14 6h4v12h-4z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkmark",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 4l-15 15-7-7-5 5 12 12 20-20z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M28 26h-24v1.333c0 0.737 0.597 1.333 1.333 1.333h21.333c0.737 0 1.333-0.597 1.333-1.333v-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M28 26h-24v-12.667l12-11.333 12 11.333v12.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de490d",
    style: {
      fill: "var(--color2, #de490d)"
    },
    d: "M8.667 16.667h6.667c0.368 0 0.667 0.299 0.667 0.667v11.333h-8v-11.333c0-0.368 0.299-0.667 0.667-0.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.05,
    d: "M16 2.667c-0.316 0-0.632 0.112-0.884 0.335l-3.573 3.207-7.543 7.124v3.593l12-10.641 12 10.641v-3.593l-7.543-7.124-3.573-3.207c-0.252-0.223-0.568-0.335-0.884-0.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.07,
    d: "M16 2c-0.316 0-0.632 0.111-0.884 0.333l-3.573 3.189-7.543 7.083v3.573l12-10.581 12 10.581v-3.573l-7.543-7.083-3.573-3.189c-0.252-0.222-0.568-0.333-0.884-0.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M29.663 13.005l-12.779-11.336c-0.252-0.223-0.568-0.335-0.884-0.335s-0.632 0.112-0.884 0.335l-12.779 11.336c-0.28 0.249-0.299 0.68-0.043 0.953l1.091 1.163c0.246 0.263 0.656 0.283 0.927 0.045l11.689-10.214 11.689 10.215c0.27 0.237 0.681 0.218 0.927-0.045l1.091-1.163c0.257-0.274 0.237-0.705-0.043-0.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M19.333 16.667h4c0.368 0 0.667 0.299 0.667 0.667v4c0 0.368-0.299 0.667-0.667 0.667h-4c-0.368 0-0.667-0.299-0.667-0.667v-4c0-0.368 0.299-0.667 0.667-0.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-news",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M28.667 7.333h-2v20h2c0.737 0 1.333-0.597 1.333-1.333v-17.333c0-0.737-0.597-1.333-1.333-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5286ff",
    style: {
      fill: "var(--color3, #5286ff)"
    },
    d: "M27.333 26v-20c0-0.737-0.597-1.333-1.333-1.333h-22.667c-0.737 0-1.333 0.597-1.333 1.333v20c0 0.737 0.597 1.333 1.333 1.333h25.333c-0.737 0-1.333-0.597-1.333-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M24.667 11.333h-20c-0.368 0-0.667-0.299-0.667-0.667v-1.333c0-0.368 0.299-0.667 0.667-0.667h20c0.368 0 0.667 0.299 0.667 0.667v1.333c0 0.368-0.299 0.667-0.667 0.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M12.667 24h-8c-0.368 0-0.667-0.299-0.667-0.667v-8.667c0-0.368 0.299-0.667 0.667-0.667h8c0.368 0 0.667 0.299 0.667 0.667v8.667c0 0.368-0.299 0.667-0.667 0.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M25.333 16h-9.333v-1.333c0-0.368 0.299-0.667 0.667-0.667h8c0.368 0 0.667 0.299 0.667 0.667v1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6eeff",
    style: {
      fill: "var(--color5, #e6eeff)"
    },
    d: "M16 16h9.333v2h-9.333v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccdcff",
    style: {
      fill: "var(--color6, #ccdcff)"
    },
    d: "M16 18h9.333v2h-9.333v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3cbff",
    style: {
      fill: "var(--color7, #b3cbff)"
    },
    d: "M16 20h9.333v2h-9.333v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9abaff",
    style: {
      fill: "var(--color8, #9abaff)"
    },
    d: "M24.667 24h-8c-0.368 0-0.667-0.299-0.667-0.667v-1.333h9.333v1.333c0 0.368-0.299 0.667-0.667 0.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M28 5.333h-24c-0.737 0-1.333 0.597-1.333 1.333v17.333c0 0.737 0.597 1.333 1.333 1.333h5.333v5.332c0 0.594 0.718 0.891 1.138 0.471l5.803-5.803h11.725c0.737 0 1.333-0.597 1.333-1.333v-17.333c0-0.737-0.597-1.333-1.333-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.05,
    d: "M14.667 22.667h2.667c0.368 0 0.667-0.299 0.667-0.667v-8c0-0.368-0.299-0.667-0.667-0.667h-2.667c-0.368 0-0.667 0.299-0.667 0.667v8c0 0.368 0.299 0.667 0.667 0.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.07,
    d: "M14.818 22.333h2.365c0.267 0 0.485-0.217 0.485-0.485v-7.697c0-0.267-0.217-0.485-0.485-0.485h-2.365c-0.267 0-0.485 0.217-0.485 0.485v7.698c0 0.267 0.217 0.484 0.485 0.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.15,
    d: "M18.659 10.268c0 1.329-1.19 2.406-2.659 2.406s-2.659-1.077-2.659-2.406c0-1.329 1.19-2.406 2.659-2.406s2.659 1.077 2.659 2.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16 11.821c1.133 0 1.767-0.712 1.767-1.592s-0.669-1.563-1.767-1.563-1.767 0.683-1.767 1.563c0 0.88 0.633 1.592 1.767 1.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M14.667 14h2.667v8h-2.667v-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-doc",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    style: {
      fill: "var(--color9, #50e6ff)"
    },
    d: "M26 10.667v16.667c0 0.737-0.597 1.333-1.333 1.333h-17.333c-0.737 0-1.333-0.597-1.333-1.333v-22.667c0-0.737 0.597-1.333 1.333-1.333h11.333l2 5.333 5.333 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M18.667 3.333v6c0 0.737 0.597 1.333 1.333 1.333h6l-7.333-7.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#057093",
    style: {
      fill: "var(--color10, #057093)"
    },
    d: "M21.667 16h-11.333c-0.184 0-0.333-0.149-0.333-0.333v-0.667c0-0.184 0.149-0.333 0.333-0.333h11.333c0.184 0 0.333 0.149 0.333 0.333v0.667c0 0.184-0.149 0.333-0.333 0.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#057093",
    style: {
      fill: "var(--color10, #057093)"
    },
    d: "M20.333 18.667h-10c-0.184 0-0.333-0.149-0.333-0.333v-0.667c0-0.184 0.149-0.333 0.333-0.333h10c0.184 0 0.333 0.149 0.333 0.333v0.667c0 0.184-0.149 0.333-0.333 0.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#057093",
    style: {
      fill: "var(--color10, #057093)"
    },
    d: "M21.667 21.333h-11.333c-0.184 0-0.333-0.149-0.333-0.333v-0.667c0-0.184 0.149-0.333 0.333-0.333h11.333c0.184 0 0.333 0.149 0.333 0.333v0.667c0 0.184-0.149 0.333-0.333 0.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#057093",
    style: {
      fill: "var(--color10, #057093)"
    },
    d: "M20.333 24h-10c-0.184 0-0.333-0.149-0.333-0.333v-0.667c0-0.184 0.149-0.333 0.333-0.333h10c0.184 0 0.333 0.149 0.333 0.333v0.667c0 0.184-0.149 0.333-0.333 0.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info4",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e74c3c",
    style: {
      fill: "var(--color11, #e74c3c)"
    },
    d: "M16 1.28c-8.123 0-14.72 6.598-14.72 14.72s6.598 14.72 14.72 14.72c8.123 0 14.72-6.598 14.72-14.72s-6.598-14.72-14.72-14.72zM16 2.56c7.43 0 13.44 6.010 13.44 13.44s-6.010 13.44-13.44 13.44c-7.43 0-13.44-6.010-13.44-13.44s6.010-13.44 13.44-13.44zM16 7.040c-1.060 0-1.92 0.86-1.92 1.92s0.86 1.92 1.92 1.92c1.060 0 1.92-0.86 1.92-1.92s-0.86-1.92-1.92-1.92zM13.44 13.44v1.28h1.28v8.32h-1.28v1.28h5.12v-1.28h-1.28v-9.6z"
  })), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.321 4.693c-6.245-6.252-16.375-6.258-22.627-0.014s-6.258 16.375-0.014 22.628c6.244 6.252 16.375 6.258 22.627 0.014s6.258-16.375 0.014-22.627zM18.234 26.153c0 0.247-0.2 0.447-0.447 0.447h-3.574c-0.247 0-0.447-0.2-0.447-0.447v-13.269c0-0.247 0.2-0.447 0.447-0.447h3.574c0.247 0 0.447 0.2 0.447 0.447v13.269zM16 10.583c-1.429 0-2.591-1.162-2.591-2.591s1.162-2.591 2.591-2.591 2.591 1.162 2.591 2.591c0 1.429-1.163 2.591-2.591 2.591z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 22.667h2.667v-8h-2.667v8zM16 2.667c-7.367 0-13.333 5.967-13.333 13.333s5.967 13.333 13.333 13.333 13.333-5.967 13.333-13.333-5.967-13.333-13.333-13.333zM16 26.667c-5.88 0-10.667-4.787-10.667-10.667s4.787-10.667 10.667-10.667 10.667 4.787 10.667 10.667-4.787 10.667-10.667 10.667zM14.667 12h2.667v-2.667h-2.667v2.667z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 18.451l-16-12.42-16 12.42v-5.064l16-12.42 16 12.42zM28 18v12h-8v-8h-8v8h-8v-12l12-9z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 19l-6-6v-9h-4v5l-6-6-16 16v1h4v10h10v-6h4v6h10v-10h4z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-phone",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 20c-2 2-2 4-4 4s-4-2-6-4-4-4-4-6 2-2 4-4-4-8-6-8-6 6-6 6c0 4 4.109 12.109 8 16s12 8 16 8c0 0 6-4 6-6s-6-8-8-6z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-email",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 4h-26c-1.65 0-3 1.35-3 3v20c0 1.65 1.35 3 3 3h26c1.65 0 3-1.35 3-3v-20c0-1.65-1.35-3-3-3zM12.461 17.199l-8.461 6.59v-15.676l8.461 9.086zM5.512 8h20.976l-10.488 7.875-10.488-7.875zM12.79 17.553l3.21 3.447 3.21-3.447 6.58 8.447h-19.579l6.58-8.447zM19.539 17.199l8.461-9.086v15.676l-8.461-6.59z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pass",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 32c-0.072 0-0.144-0.008-0.217-0.024-0.458-0.102-0.783-0.507-0.783-0.976v-15h-15c-0.469 0-0.875-0.326-0.976-0.783s0.129-0.925 0.553-1.123l30-14c0.381-0.178 0.833-0.098 1.13 0.199s0.377 0.749 0.199 1.13l-14 30c-0.167 0.358-0.524 0.577-0.906 0.577zM5.508 14h11.492c0.552 0 1 0.448 1 1v11.492l10.931-23.423-23.423 10.931z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bubble",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2c8.837 0 16 5.82 16 13s-7.163 13-16 13c-0.849 0-1.682-0.054-2.495-0.158-3.437 3.437-7.539 4.053-11.505 4.144v-0.841c2.142-1.049 4-2.961 4-5.145 0-0.305-0.024-0.604-0.068-0.897-3.619-2.383-5.932-6.024-5.932-10.103 0-7.18 7.163-13 16-13z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3c-3.472 0-6.737 1.352-9.192 3.808s-3.808 5.72-3.808 9.192c0 3.472 1.352 6.737 3.808 9.192s5.72 3.808 9.192 3.808c3.472 0 6.737-1.352 9.192-3.808s3.808-5.72 3.808-9.192c0-3.472-1.352-6.737-3.808-9.192s-5.72-3.808-9.192-3.808zM16 0v0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM14 22h4v4h-4zM14 6h4v12h-4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.aa82d6411a6372af37bb80c9529c8da9.svg";
export { ForwardRef as ReactComponent };